import React, {useCallback, useContext} from 'react';
import {EditorContext, useEditorState} from "@tiptap/react";
import {FaAlignCenter, FaAlignJustify, FaAlignLeft, FaAlignRight} from "react-icons/fa";

const alignIcon = {
    left: FaAlignLeft,
    center: FaAlignCenter,
    right: FaAlignRight,
    justify: FaAlignJustify,
}

const alignTitle = {
    left: "Alinhar à esquerda (Ctrl+Shift+L)",
    center: "Alinhar no centro (Ctrl+Shift+E)",
    right: "Alinhar à direita (Ctrl+Shift+R)",
    justify: "Justificar (Ctrl+Shift+J)"
}

const RichTextAlignButton = ({align}) => {
    const {editor} = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null

    const isActive = useEditorState({
        editor,
        selector: ({ editor }) => {
            if (!editor) return false;

            return (
                editor.isActive({ textAlign: align }) || editor.isActive('image', { align })
            );
        },
    });

    const Icon = alignIcon[align];

    const handleClick = useCallback(
        (e) => {
            e.preventDefault();
            if (!editor) return

            const chain = editor.chain().focus()
            chain.setTextAlign(align).run()

            editor.commands.setImageAlign(align);
        },
        [editor, align]
    )

    return (
        <button className={"rich-text-button" + (isActive ? " active" : "")} onClick={handleClick} title={alignTitle[align]}>
            <Icon className="rich-text-button-icon"/>
        </button>
    );
};

export default RichTextAlignButton;